import { FC } from "react";
import { Link, useLocation } from "react-router-dom";
export const VerticalLine = () => (
  <div className="border-l border-gray h-4 mx-2"></div>
);
const NavBar: FC = () => {
  const location = useLocation();
  return (
    <nav className="mt-4 md:mt-6 flex text-xs md:text-sm">
      <Link
        to="/"
        className={`mx-2 ${
          location.pathname === "/" ? "text-blue" : "text-gray"
        }`}
      >
        Home
      </Link>
      <VerticalLine />
      <a
        href="mailto:contact@mymaani.com?subject=Support Inquiry"
        className={`mx-2 ${
          location.pathname.startsWith("/support") ? "text-blue" : "text-gray"
        }`}
      >
        Support
      </a>
      <VerticalLine />
      <Link
        to="/privacy-policy"
        className={`mx-2 ${
          location.pathname === "/privacy-policy" ? "text-blue" : "text-gray"
        }`}
      >
        Privacy Policy
      </Link>
    </nav>
  );
};
export default NavBar;
